/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Email_AlertsInputs */

const en_jobs_email_alerts = /** @type {(inputs: Jobs_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email alerts`)
};

const de_jobs_email_alerts = /** @type {(inputs: Jobs_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Benachrichtigungen`)
};

const fr_jobs_email_alerts = /** @type {(inputs: Jobs_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertes e-mail`)
};

const es_jobs_email_alerts = /** @type {(inputs: Jobs_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertas por correo`)
};

const it_jobs_email_alerts = /** @type {(inputs: Jobs_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvisi email`)
};

const nl_jobs_email_alerts = /** @type {(inputs: Jobs_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mailmeldingen`)
};

const pl_jobs_email_alerts = /** @type {(inputs: Jobs_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiadomienia e-mail`)
};

const fi_jobs_email_alerts = /** @type {(inputs: Jobs_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sähköposti-ilmoitukset`)
};

const da_jobs_email_alerts = /** @type {(inputs: Jobs_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail-advarsler`)
};

const sv_jobs_email_alerts = /** @type {(inputs: Jobs_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-postaviseringar`)
};

/**
* | output |
* | --- |
* | "Email alerts" |
*
* @param {Jobs_Email_AlertsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_email_alerts = /** @type {((inputs?: Jobs_Email_AlertsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Email_AlertsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_email_alerts(inputs)
	if (locale === "fr") return fr_jobs_email_alerts(inputs)
	if (locale === "es") return es_jobs_email_alerts(inputs)
	if (locale === "it") return it_jobs_email_alerts(inputs)
	if (locale === "nl") return nl_jobs_email_alerts(inputs)
	if (locale === "pl") return pl_jobs_email_alerts(inputs)
	if (locale === "fi") return fi_jobs_email_alerts(inputs)
	if (locale === "da") return da_jobs_email_alerts(inputs)
	if (locale === "sv") return sv_jobs_email_alerts(inputs)
	return en_jobs_email_alerts(inputs)
});